export enum UserStatus {
  PENDING = 'pending',
  DECLINED = 'declined',
  APPROVED = 'approved',
  ACTIVE = 'active',
  CANCELED = 'canceled',
  PAUSED = 'paused',
  TRASH = 'trash',
}
